export default __webpack_public_path__ + "assets/front/scss/formulaire.940916a3105370f133eeec12813c3806.css";